import type { SubscriptionTier } from './types';

/** Subscription tiers from lowest to highest. The single source of tier ordering. */
export const TIERS_LOW_TO_HIGH: SubscriptionTier[] = ['free', 'pro', 'elite'];
